import { Routes } from '@angular/router';
import { ObjectiveManagementComponent } from './components/objective-management/objective-management.component';
import { CampbellProjects } from './components/campbell-projects/campbell-projects';
import { CategoriesComponent } from './components/categories/categories.component';
import { TagsManagementComponent } from './components/tags-management/tags-management.component';
import { ExperimentsComponent } from './components/experiments/experiments.component';
import { CreateEditExperimentComponent } from './components/create-edit-experiment/create-edit-experiment.component';
import { CreateEditBatchComponent } from './components/create-edit-batch/create-edit-batch.component';
import { IngredientsComponent } from './components/ingredients/ingredients.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { BatchFormGuard } from './guards/batch-deactivate.guard';
import { authGuard } from './guards/auth.guard';
import { mobileRouteGuard } from './guards/mobile-route.guard';
import { MobileNoteDeactivateGuard } from './guards/mobile-note-deactivate.guard';

export const routes: Routes = [
  {
    path: 'welcome',
    component: WelcomeComponent,
  },
  {
    path: 'projects',
    component: CampbellProjects,
    canActivate: [authGuard],
  },
  {
    path: 'batches/:batchId/notes',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/batch-notes/batch-notes.component').then((m) => m.MobileBatchNotesComponent),
  },
  {
    path: 'batches/:batchId/notes/entry',
    canActivate: [authGuard],
    canDeactivate: [MobileNoteDeactivateGuard],
    loadComponent: () =>
      import('./components/batch-note-editor/mobile-note-editor.component').then((m) => m.MobileNoteEditorComponent),
  },
  // {
  //   path: 'experiments',
  //   component: HomeComponent,
  // },
  {
    path: 'ingredients',
    canActivate: [authGuard, mobileRouteGuard],
    data: { blockOnMobile: true },
    loadComponent: () => import('./components/ingredients/ingredients.component').then((m) => m.IngredientsComponent),
  },
  {
    path: 'experiments/create',
    canActivate: [authGuard, mobileRouteGuard],
    data: { mode: 'create', blockOnMobile: true },
    loadComponent: () =>
      import('./components/create-edit-experiment/create-edit-experiment.component').then(
        (m) => m.CreateEditExperimentComponent
      ),
  },
  {
    path: 'experiments/edit/:id',
    canActivate: [authGuard, mobileRouteGuard],
    data: { mode: 'edit', blockOnMobile: true },
    loadComponent: () =>
      import('./components/create-edit-experiment/create-edit-experiment.component').then(
        (m) => m.CreateEditExperimentComponent
      ),
  },
  {
    path: 'categories',
    canActivate: [authGuard, mobileRouteGuard],
    data: { blockOnMobile: true },
    loadComponent: () => import('./components/categories/categories.component').then((m) => m.CategoriesComponent),
  },
  {
    path: 'tags',
    canActivate: [authGuard, mobileRouteGuard],
    data: { blockOnMobile: true },
    loadComponent: () =>
      import('./components/tags-management/tags-management.component').then((m) => m.TagsManagementComponent),
  },
  {
    path: 'objectives',
    canActivate: [authGuard, mobileRouteGuard],
    data: { blockOnMobile: true },
    loadComponent: () =>
      import('./components/objective-management/objective-management.component').then(
        (m) => m.ObjectiveManagementComponent
      ),
  },
  {
    path: 'experiments',
    canActivate: [authGuard, mobileRouteGuard],
    data: { blockOnMobile: true },
    loadComponent: () => import('./components/experiments/experiments.component').then((m) => m.ExperimentsComponent),
    children: [
      {
        path: 'batch',
        canDeactivate: [BatchFormGuard],
        loadComponent: () =>
          import('./components/create-edit-batch/create-edit-batch.component').then((m) => m.CreateEditBatchComponent),
      },
      // other child routes...
    ],
  },
  {
    path: 'products',
    canActivate: [authGuard, mobileRouteGuard],
    data: { blockOnMobile: true },
    loadComponent: () => import('./components/products/products.component').then((m) => m.ProductsComponent),
  },
  {
    path: 'analytics',
    canActivate: [authGuard, mobileRouteGuard],
    data: { blockOnMobile: true },
    loadComponent: () => import('./components/pages/analytics/analytics.component').then((m) => m.AnalyticsComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'welcome',
  },
  {
    path: '**',
    redirectTo: 'welcome',
  },
];
